exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chip-wrapper[data-v-17b6680c] {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.custom-chip[data-v-17b6680c] {\n  width: 150px;\n  background: #257439;\n  color: white;\n  border-radius: 10px;\n}\n", ""]);

// exports
